// import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import React, { useEffect, useState} from "react";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import MyCvLoader from "./MyCvLoader";
import { findMemberByPfNumber, uploadCV } from "../../../api/apiServices";
import { useMutation } from "react-query";
import Swal from "sweetalert2";

export const MyCv = ({ member }) => {
	const navigate = useNavigate();

	const [data, setData] = useState({
		pf_number: "",
		fullname: "",
		mobile_number: "",
		email: "",
		profession: "",
		selectedFile: null,
		previewUrl: "",
	});
	useEffect(() => {
		data.selectedFile &&
			setData((prevData) => ({
				...prevData,
				previewUrl: URL.createObjectURL(data.selectedFile),
			}));
	}, [data.selectedFile]);

	useEffect(() => {
		member?.pfNumber &&
			findMemberByPfNumber(member?.pfNumber).then((res) => {
				setData((prevData) => ({
					...prevData,
					pf_number: res.member?.pf_number,
					fullname:
						res.member?.first_name +
						" " +
						res.member?.middle_name +
						" " +
						res.member?.last_name,
					mobile_number: res.member?.mobile_number,
					email: res.member?.email,
					profession: res.member?.profession,
				}));
			});
	}, [member?.pfNumber]);

	const handleSubmit = (e) => {
		e.preventDefault();
		if (!data.selectedFile) {
			Swal.fire({
				title: "Oooops!",
				text: "Please upload your new CV or Cancel!",
				icon: "warning",
				width: 400,
				padding: "3em",
			}).then((result) => {
				if (result.isConfirmed) {
					return false;
				}
			});
		} else {
			let formData = new FormData();

			formData.append("file", data.selectedFile);
			formData.set("pf_number", data.pf_number);
			formData.set("fullname", data.fullname);
			formData.set("mobile_number", data.mobile_number);
			formData.set("email", data.email);
			formData.set("profession", data.profession);
			createCVMutation.mutate(formData);
		}
	};

	const createCVMutation = useMutation(uploadCV, {
		onSuccess: async (res) => {
			if (!res.success) {
				toast.error(res.message, {
					duration: 5000,
					className: "toast-message",
				});
				return false;
			} else {
				toast.success(res.message, {
					duration: 5000,
					className: "toast-message",
				});
				// navigate(-1);
			}
		},
		onError: async (err) => {
			toast.error(err.message, {
				duration: 5000,
				className: "toast-message",
			});
		},
	});

	const handleCancel = () => {
		navigate("/home");
	};

	const myCv = (
		<>
			<form onSubmit={handleSubmit}>
				<fieldset className="col-sm-6">
					<legend>PERSONAL INFORMATION </legend>
					<label
						htmlFor="payment_mode"
						className="col-sm-4 col-form-label"
					>
						PF Number<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<input
							type="text"
							id="pf_number"
							disabled
							value={data.pf_number}
							className="form-control"
						/>
					</div>
					<label
						htmlFor="payment_mode"
						className="col-sm-4 col-form-label"
					>
						Full Name<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<input
							type="text"
							id="pf_number"
							disabled
							value={data.fullname}
							className="form-control"
						/>
					</div>
					<label
						htmlFor="payment_mode"
						className="col-sm-4 col-form-label"
					>
						Phone Number<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<input
							type="text"
							id="pf_number"
							disabled
							value={data.mobile_number}
							className="form-control"
						/>
					</div>
					<label
						htmlFor="payment_mode"
						className="col-sm-4 col-form-label"
					>
						Email Address<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<input
							type="text"
							id="pf_number"
							disabled
							value={data.email}
							maxLength={1000}
							// cols="10"
							rows="5"
							className="form-control"
						/>
					</div>
					<label htmlFor="profession" className="col-sm-4 label-text">
						Profession<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<textarea
							type="text"
							id="profession"
							disabled
							value={data.profession}
							className="form-control"
						/>
					</div>
				</fieldset>
				<fieldset className="col-sm-6">
					<legend>UPLOAD CV </legend>
					<label htmlFor="photo" className="col-sm-4 label-text">
						Curriculum Vitae<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<MyCvLoader
							name={"selectedFile"}
							data={data}
							setData={setData}
						/>
					</div>
					{data.previewUrl && (
						<>
							<label
								htmlFor="filename"
								className="col-sm-4 label-text"
							>
								File Name<span>&nbsp;&nbsp;*</span>
							</label>
							<div className="col-sm-8">
								<span
									style={{
										fontSize: "14px",
										fontWeight: "bold",
										color: "blue",
										cursor: "pointer",
									}}
								>
									{" "}
									{data.selectedFile.name}{" "}
								</span>
							</div>
						</>
					)}
				</fieldset>

				<fieldset className="col-sm-12">
					<div className="panel-footer">
						<div className="row">
							<div className="col-sm-2">
								<button
									type="submit"
									className="btn btn-success btn-block"
								>
									Submit
								</button>
								&nbsp;&nbsp;&nbsp;&nbsp;
							</div>
							<div className="col-sm-2">
								<button
									type="button"
									onClick={handleCancel}
									className="btn btn-danger btn-block"
								>
									Cancel
								</button>
							</div>
						</div>
					</div>
				</fieldset>
			</form>
		</>
	);

	return (
		<>
			<Toaster toastOptions={{ position: "top-center" }} />
			<section className="content-header">
				<h1>
					<i className="fas file"></i> Curriculum Vitae
				</h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
											<span>My Curriculum Vitae</span>
										</h4>
									</div>
								</div>
							</div>
							<div className="panel-body">{myCv}</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};
